import React, { useEffect } from "react";
import Signup from "../pages/Signup";

export default function SignupModal({ show, onClose, initialRole = null }) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 transition-opacity duration-200 px-2 sm:px-4">
      <div
        className="w-full max-w-lg bg-white rounded-2xl shadow-2xl p-4 sm:p-8 mx-auto relative flex flex-col"
        style={{
          maxHeight: '100vh',
          minHeight: '0',
          overflowY: 'auto',
          paddingBottom: 0,
          position: 'relative',
          zIndex: 1001
        }}
        aria-modal="true"
        role="dialog"
        tabIndex={-1}
      >
        <div className="sticky top-0 z-20 bg-white rounded-t-2xl pb-2 flex justify-end" style={{ position: 'sticky', top: 0, zIndex: 20 }}>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-gray-400 hover:text-gray-600 text-3xl focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 rounded-full p-1 -mr-1"
            tabIndex={0}
            style={{ position: 'relative', zIndex: 20 }}
          >&times;</button>
        </div>
        <div className="flex-1 min-h-0">
          <Signup onSuccess={onClose} initialRole={initialRole} />
        </div>
      </div>
    </div>
  );
}
